// import React, { useState, useEffect, useCallback, useRef } from "react";
// import config from "../../Common/Configurations/APIConfig";
// import apiService from "../../Common/Configurations/APIService";
// import Header from "../../Common/Layout/Header";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import Login from "../../Authentication/Login";
// import { Link } from "react-router-dom";
// import "animate.css";
// import "./Marketing.css";
// import moment from "moment";
// import MarketingTabs from "./MarketingTabs";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import { toast } from "react-toastify";
// import PremiumModernTemplate from "../Package/PackagePdfTemplates/PremiumModernTemplate";

// const initialFieldValues = {
//   campaignId: "00000000-0000-0000-0000-000000000000",
//   marketingChannel: "",
//   packageId: "",
//   customerIds: [],
//   campaignMessage: "",
// };

// // Package type options
// const packageTypeOptions = ["Holiday", "Umrah", "Hajj"];

// const Marketing = () => {
//   const { user, loading, refreshUserProfile } = useAuth();
//   const [btnLoading, setBtnLoading] = useState(false);
//   const [values, setValues] = useState(initialFieldValues);
//   const [errors, setErrors] = useState({});
//   const [addShow, setAddShow] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [itemToDelete, setItemToDelete] = useState(null);
//   const [packages, setPackages] = useState([]);
//   const [customers, setCustomers] = useState([]);
//   const [selectedCount, setSelectedCount] = useState(0);
//   const [selectedPackage, setSelectedPackage] = useState(null);
//   const [previewMode, setPreviewMode] = useState(false);
//   const [isLoading, setIsLoading] = useState({
//     packages: false,
//     customers: false,
//   });
//   const [pageNumber, setPageNumber] = useState(1);
//   const [pageSize] = useState(20);
//   const [totalPages, setTotalPages] = useState(0);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [packageSearchTerm, setPackageSearchTerm] = useState("");
//   const [customerSearchTerm, setCustomerSearchTerm] = useState("");
//   const [filterType, setFilterType] = useState("");
//   const [customerMasterList, setCustomerMasterList] = useState(new Map());
//   const [selectedPackageDetails, setSelectedPackageDetails] = useState(null);
//   const pdfTemplateRef = useRef(null);

//   const marketingChannels = [
//     { value: "email", label: "Email", icon: "ri-mail-line", color: "primary" },
//     {
//       value: "whatsapp",
//       label: "WhatsApp",
//       icon: "ri-whatsapp-line",
//       color: "success",
//     },
//   ];

//   const resetForm = () => {
//     setValues(initialFieldValues);
//     setAddShow(false);
//     setBtnLoading(false);
//     setPackageSearchTerm("");
//     setCustomerSearchTerm("");
//     setFilterType("");
//     setErrors({});
//     setPreviewMode(false);
//   };

//   const handleAddClose = () => {
//     resetForm();
//   };

//   const handleCloseDeleteModal = () => {
//     setShowDeleteModal(false);
//     setItemToDelete(null);
//   };
//   // Add this new function inside your Marketing.js component

// const handleWhatsappShareClick = async (pkg) => {

//   const updatedProfile = await refreshUserProfile();

//   // 2. Check if the user has connects available
//   if (updatedProfile && updatedProfile.connects > 0) {
//     // 3a. If connects are available, call the original function to open the modal
//     openPackageModal(pkg, "whatsapp");
//   } else {
//     // 3b. If no connects, show an error message and do nothing else
//     toast.error("You have no WhatsApp connects left. Please recharge to continue.");
//   }
// };

//   const getPackages = useCallback(async () => {
//     setIsLoading((prev) => ({ ...prev, packages: true }));
//     try {
//       let resourceUrl = `${config.GETPACKAGEBYCOMAPANYID}/${user?.cid}?PageNumber=${pageNumber}&PageSize=${pageSize}`;

//       if (packageSearchTerm) {
//         resourceUrl += `&search=${encodeURIComponent(packageSearchTerm)}`;
//       }

//       if (filterType) {
//         resourceUrl += `&type=${encodeURIComponent(filterType)}`;
//       }

//       const res = await apiService.getAll(resourceUrl);
//       setPackages(res.data);
//       setTotalPages(res.totalPages);
//       setTotalRecords(res.totalRecords);
//     } catch (error) {
//       console.error("Error fetching packages:", error);
//     } finally {
//       setIsLoading((prev) => ({ ...prev, packages: false }));
//     }
//  }, [user?.cid, pageSize, pageNumber, packageSearchTerm, filterType]);

//   const getCustomers = useCallback(
//     async (search = "") => {
//       setIsLoading((prev) => ({ ...prev, customers: true }));
//       try {
//         const url = `${config.GETALLCUSTOMERSBYCOMPANYID}/${user?.cid}${
//           search ? `?search=${encodeURIComponent(search)}` : ""
//         }`;
//         const res = await apiService.getSingle(url);
//         setCustomers(res);

//         // Only auto-select all customers on the initial load (when no search term is present).
//         // This prevents re-selecting when the user unchecks "Select All".
//         if (search === "") {
//           setValues((prev) => ({
//             ...prev,
//             customerIds: res.map((customer) => customer.customerId),
//           }));
//         }
//       } catch (error) {
//         console.error("Error fetching customers:", error);
//       } finally {
//         setIsLoading((prev) => ({ ...prev, customers: false }));
//       }
//       // Remove the dependency on customerIds.length to break the loop.
//     },
//     [user?.cid]
//   );

//   const handleAddShow = () => {
//     setValues(initialFieldValues);
//     setAddShow(true);
//     getPackages();
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setValues({
//       ...values,
//       [name]: value,
//     });
//   };

//   const handleCustomerSelection = (customerId, isChecked) => {
//     setValues((prev) => {
//       const customerIds = isChecked
//         ? [...prev.customerIds, customerId]
//         : prev.customerIds.filter((id) => id !== customerId);
//       return { ...prev, customerIds };
//     });
//   };

//   const handleSelectAll = (e) => {
//     const isChecked = e.target.checked;
//     setValues((prev) => {
//       let updatedCustomerIds = [...prev.customerIds];
//       const filteredIds = customers.map((customer) => customer.customerId);

//       if (isChecked) {
//         updatedCustomerIds = [
//           ...new Set([...updatedCustomerIds, ...filteredIds]),
//         ];
//       } else {
//         updatedCustomerIds = updatedCustomerIds.filter(
//           (id) => !filteredIds.includes(id)
//         );
//       }

//       return { ...prev, customerIds: updatedCustomerIds };
//     });
//   };

//   const validate = () => {
//     let temp = {};
//     temp.marketingChannel = values.marketingChannel !== "";
//     temp.packageId = values.packageId !== "";
//     temp.customerIds = values.customerIds.length > 0;
//     temp.campaignMessage = values.campaignMessage !== "";
//     setErrors(temp);
//     return Object.values(temp).every((x) => x === true);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     setBtnLoading(true);

//     if (values.marketingChannel === 'whatsapp') {
//       try {
//         if (!selectedPackageDetails || !pdfTemplateRef.current) {
//           throw new Error("Package details not loaded. Please re-open the modal.");
//         }

//         // 1. Generate PDF from the hidden template
//         const input = pdfTemplateRef.current;
//         const canvas = await html2canvas(input, { scale: 1, useCORS: true });
//         const imgData = canvas.toDataURL("image/png");
//         const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
//         const pdfWidth = pdf.internal.pageSize.getWidth();
//         const pdfHeight = pdf.internal.pageSize.getHeight();
//         const ratio = canvas.height / canvas.width;
//         const imgHeight = pdfWidth * ratio;
//         let heightLeft = imgHeight;
//         let position = 0;
//         pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
//         heightLeft -= pdfHeight;
//         while (heightLeft > 0) {
//           position = position - pdfHeight;
//           pdf.addPage();
//           pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
//           heightLeft -= pdfHeight;
//         }
//         const pdfBlob = pdf.output("blob");
//         const pdfFile = new File([pdfBlob], `${selectedPackage.packageName}.pdf`, { type: "application/pdf" });

//         // 2. Get phone numbers
//         const customerPhones = customers
//             .filter(c => values.customerIds.includes(c.customerId))
//             .map(c => c.phoneNumber.startsWith("91") ? c.phoneNumber : "91" + c.phoneNumber);

//         // 3. Create FormData for the BULK endpoint
//         const formData = new FormData();
//         formData.append("CompanyId", user.cid);
//         formData.append("Caption", values.campaignMessage);
//         formData.append("PdfFile", pdfFile);
//         customerPhones.forEach(phone => {
//             formData.append("CustomerPhones", phone);
//         });

//         // 4. Call the BULK API
//         await apiService.postWithFile(config.SENDBULKPDF, formData);

//         // 5. Refresh user profile for updated connects balance
//         await refreshUserProfile();
//         resetForm();

//       } catch (error) {
//           const errorMessage = error.response?.data?.message || "Failed to send WhatsApp message. Please try again.";

//                   toast.error(errorMessage);
//       } finally {
//           setBtnLoading(false);
//       }

//     } else if (values.marketingChannel === 'email') {
//       // Email logic (unchanged)
//       try {
//         await apiService.create(config.MARKETING, values);
//         resetForm();
//       } catch (error) {
//         console.error("Error sending email campaign:", error);
//         toast.error("Failed to send email campaign.");
//       } finally {
//         setBtnLoading(false);
//       }
//     }
//   };

//   // NEW async version of openPackageModal
//   const openPackageModal = async (pkg, channel) => {
//     setSelectedPackage(pkg);
//     // Reset all relevant states for a clean opening
//     setCustomers([]);
//     setCustomerMasterList(new Map());
//     setCustomerSearchTerm("");
//     setValues({
//       ...initialFieldValues,
//       packageId: pkg.packageId,
//       marketingChannel: channel,
//       campaignMessage: `Exciting offer! ${pkg.packageName} for just ${
//         pkg.currency
//       } ${pkg.price.toLocaleString()}`,
//       customerIds: [], // Start with an empty selection; the useEffect will populate it
//     });
//     setAddShow(true); // This will trigger the main data-fetching useEffect
//   try {
//       const fullDetails = await apiService.get(`${config.GETPACKAGEDETAILS}/${pkg.packageId}`);
//       setSelectedPackageDetails(fullDetails);
//     } catch (error) {
//       console.error("Failed to fetch full package details:", error);
//       toast.error("Could not load package details for PDF generation.");
//     }
//   };

//   const GetFirstPageData = () => {
//     setPageNumber(1);
//   };

//   const GetLastPageData = () => {
//     setPageNumber(totalPages);
//   };

//   const GetPageData = (number) => {
//     setPageNumber(number);
//   };

//   const handleReset = () => {
//     setPackageSearchTerm("");
//     setFilterType("");
//     setPageNumber(1);
//     getPackages();
//   };

//    useEffect(() => {
//     if (user?.cid && !loading) {
//       getPackages();
//     }
//     // --- CHANGE 6: Update dependency array to use packageSearchTerm ---
//   }, [loading, user?.cid, getPackages, pageNumber, packageSearchTerm, filterType]);

//   useEffect(() => {
//     setPageNumber(1);
//     // --- CHANGE 7: This effect should only run for package search/filter ---
//   }, [packageSearchTerm, filterType]);

//   useEffect(() => {
//     // Don't run if the modal is closed
//     if (!addShow) {
//       return;
//     }

//      const getCustomers = async () => {
//       setIsLoading((prev) => ({ ...prev, customers: true }));
//       try {
//         // --- CHANGE 8: Use customerSearchTerm for the customer API call ---
//         const url = `${config.GETALLCUSTOMERSBYCOMPANYID}/${user?.cid}${
//           customerSearchTerm ? `?search=${encodeURIComponent(customerSearchTerm)}` : ""
//         }`;
//         const newCustomers = await apiService.getSingle(url);

//         const updatedMasterList = new Map(customerMasterList);
//         newCustomers.forEach((customer) => {
//           updatedMasterList.set(customer.customerId, customer);
//         });
//         setCustomerMasterList(updatedMasterList);

//         // --- CHANGE 9: Update logic to depend on customerSearchTerm ---
//         if (customerSearchTerm) {
//           setCustomers(newCustomers);
//         } else {
//           setCustomers(Array.from(updatedMasterList.values()));
//         }

//         if (customerMasterList.size === 0 && !customerSearchTerm) {
//           setValues((prev) => ({
//             ...prev,
//             customerIds: newCustomers.map((c) => c.customerId),
//           }));
//         }
//       } catch (error) {
//         console.error("Error fetching customers:", error);
//       } finally {
//         setIsLoading((prev) => ({ ...prev, customers: false }));
//       }
//     };

//     // Use a debounce to prevent API calls on every keystroke
//     const debounceTimer = setTimeout(() => {
//         getCustomers();
//     }, 300); // 300ms delay

//     return () => clearTimeout(debounceTimer);

//     // --- CHANGE 10: Update dependency array to use customerSearchTerm ---
//   }, [addShow, customerSearchTerm, user?.cid]); // Removed customerMasterList from deps to prevent loops

//   useEffect(() => {
//     setSelectedCount(values.customerIds.length);
//   }, [values.customerIds]);

//   const renderPageNumbers = () => {
//     const pageNumbers = [];
//     for (let i = 1; i <= totalPages; i++) {
//       pageNumbers.push(i);
//     }
//     return pageNumbers.map((number) => (
//       <li
//         className={`page-item ${pageNumber === number ? "active" : ""}`}
//         key={number}
//         onClick={() => GetPageData(number)}
//       >
//         <Link className="page-link">{number}</Link>
//       </li>
//     ));
//   };

//   const renderPreview = () => {
//     if (!selectedPackage) return null;

//     return (
//       <div className="preview-container p-4 border rounded bg-light">
//         {values.marketingChannel === "email" ? (
//           <div className="email-preview">
//             <h5 className="text-primary">Email Preview</h5>
//             <div className="email-content mt-3 p-3 bg-white rounded">
//               <h4>Special Offer: {selectedPackage.packageName}</h4>
//               <img
//                 src={
//                   selectedPackage.imageSrc ||
//                   "https://via.placeholder.com/600x300"
//                 }
//                 className="img-fluid rounded my-3"
//                 alt={selectedPackage.packageName}
//               />
//               <p>
//                 <strong>Package Details:</strong>
//               </p>
//               <ul>
//                 <li>Destination: {selectedPackage.packageName}</li>
//                 <li>Duration: {selectedPackage.duration}</li>
//                 <li>
//                   Price: {selectedPackage.currency}{" "}
//                   {selectedPackage.price.toLocaleString()}
//                 </li>
//                 <li>
//                   Start Date:{" "}
//                   {new Date(selectedPackage.startedDate).toLocaleDateString()}
//                 </li>
//               </ul>
//               <p>{selectedPackage.description}</p>
//             </div>
//           </div>
//         ) : (
//           <div className="whatsapp-preview">
//             <h5 className="text-success">WhatsApp Preview</h5>
//             <div className="whatsapp-message mt-3 p-3 bg-white rounded">
//               <div className="d-flex align-items-center mb-2">
//                 <div className="avatar-xs me-2">
//                   <div className="avatar-title rounded-circle bg-soft-success text-success">
//                     <i className="ri-whatsapp-line"></i>
//                   </div>
//                 </div>
//                 <h6 className="mb-0">Travel Agency</h6>
//               </div>
//               <div className="message-content bg-success text-white p-3 rounded">
//                 <p>{values.campaignMessage}</p>
//                 {selectedPackage.imageSrc && (
//                   <img
//                     src={selectedPackage.imageSrc}
//                     className="img-fluid rounded mt-2"
//                     alt={selectedPackage.packageName}
//                   />
//                 )}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };

//   if (loading) return <p>Loading...</p>;
//   if (!user) return <Login />;

//   return (
//     <div id="layout-wrapper" className="marketing-page">
//       <Header User={user} />
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             <div className="card">
//               <div className="p-2">
//                 <MarketingTabs pageName="MARKETING" />
//               </div>
//               <div className="card-body">
//                 {/* Search and Filter Section */}
//                 <div className="row g-3 mb-4">
//                   <div className="col-xl-4 col-lg-6">
//                     <div className="search-box">
//                       <input
//                         type="text"
//                         className="form-control search"
//                         placeholder="Search packages..."
//                         value={packageSearchTerm}
//                         onChange={(e) => setPackageSearchTerm(e.target.value)}
//                       />
//                       {/* <i className="ri-search-line search-icon"></i> */}
//                     </div>
//                   </div>
//                   <div className="col-xl-2 col-lg-3">
//                     <select
//                       name="filterType"
//                       value={filterType}
//                       onChange={(e) => setFilterType(e.target.value)}
//                       className="form-select"
//                     >
//                       <option value="">All Types</option>
//                       {packageTypeOptions.map((type, index) => (
//                         <option key={index} value={type}>
//                           {type}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div className="col-xl-2 col-lg-3">
//                     <div className="hstack gap-2">
//                       <button className="btn btn-danger" onClick={handleReset}>
//                         <i className="ri-refresh-line align-bottom me-1"></i>{" "}
//                         Reset
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="row g-4">
//                   {isLoading.packages ? (
//                     <div className="col-12 text-center py-5">
//                       <div className="spinner-grow text-primary" role="status">
//                         <span className="visually-hidden">Loading...</span>
//                       </div>
//                       <p className="mt-3 text-muted">Loading packages...</p>
//                     </div>
//                   ) : packages.length > 0 ? (
//                     packages.map((pkg) => (
//                       <div className="col-md-4 col-lg-3" key={pkg.packageId}>
//                         <div
//                           className={`card package-card h-100 animate__animated animate__fadeInUp ${
//                             values.packageId === pkg.packageId
//                               ? "selected-package"
//                               : ""
//                           }`}
//                         >
//                           <div className="card-img-container">
//                             <img
//                               src={
//                                 pkg.imageSrc || "/images/default-package.jpg"
//                               }
//                               className="card-img-top"
//                               alt={pkg.packageName}
//                             />
//                             <div className="price-badge">
//                               <span>
//                                 {pkg.currency} {pkg.price.toLocaleString()} per
//                                 person
//                               </span>
//                             </div>
//                           </div>
//                           <div className="card-body">
//                             <h5 className="">{pkg.packageName}</h5>
//                             <span className="badge bg-info me-2">
//                               {pkg.duration}
//                             </span>
//                             <span
//                               className={`badge me-2 ${
//                                 pkg.status === "Active"
//                                   ? "bg-success"
//                                   : "bg-danger"
//                               }`}
//                             >
//                               {pkg.status}
//                             </span>
//                             <div className="package-meta d-flex justify-content-between mb-2 mt-1">
//                               <span>
//                                 <i className="ri-calendar-line me-1"></i> Travel
//                                 Date :{" "}
//                                 {moment(pkg.startedDate).format("DD MMM YYYY")}
//                               </span>
//                               <span>
//                                 <i className="ri-user-line me-1"></i>
//                                 {pkg.noOfPersons}
//                               </span>
//                             </div>
//                             <p className="card-text text-muted">
//                               {pkg.description
//                                 ? `${pkg.description.substring(0, 80)}...`
//                                 : "No description available"}
//                             </p>
//                           </div>
//                           <div className="card-footer">
//                             <div className="d-flex justify-content-between align-items-center">
//                               <button
//     className="btn btn-success btn-sm me-2"
//     onClick={() => handleWhatsappShareClick(pkg)}
//     title="WhatsApp Campaign"
// >
//     Share <i className="ri-whatsapp-line"></i>
// </button>
//                               <button
//                                 className="btn btn-primary btn-sm"
//                                 onClick={() => openPackageModal(pkg, "email")}
//                                 title="Email Campaign"
//                               >
//                                 Share <i className="ri-mail-line"></i>
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div className="col-12 text-center py-5">
//                       <div className="text-muted">
//                         <i className="ri-hotel-line display-5"></i>
//                         <h5 className="mt-3">No packages available</h5>
//                         <p>Please check back later or add new packages</p>
//                       </div>
//                     </div>
//                   )}
//                 </div>

//                 <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
//                   <div className="flex-shrink-0">
//                     <div className="text-muted">
//                       Showing{" "}
//                       <span className="fw-semibold">{packages.length}</span> of{" "}
//                       <span className="fw-semibold">{totalRecords}</span>{" "}
//                       Results
//                     </div>
//                   </div>
//                   <ul className="pagination pagination-separated pagination-sm mb-0">
//                     <li
//                       className={`page-item ${
//                         pageNumber === 1 ? "disabled" : ""
//                       }`}
//                       onClick={() =>
//                         pageNumber > 1 && setPageNumber(pageNumber - 1)
//                       }
//                     >
//                       <Link className="page-link">Previous</Link>
//                     </li>
//                     {renderPageNumbers()}
//                     <li
//                       className={`page-item ${
//                         pageNumber === totalPages ? "disabled" : ""
//                       }`}
//                       onClick={() =>
//                         pageNumber < totalPages && setPageNumber(pageNumber + 1)
//                       }
//                     >
//                       <Link className="page-link">Next</Link>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//          {selectedPackageDetails && (
//             <div style={{ position: "absolute", left: "-9999px", width: "210mm" }}>
//                 <div ref={pdfTemplateRef}>
//                     <PremiumModernTemplate
//                         packageData={selectedPackageDetails}
//                         user={user}
//                     />
//                 </div>
//             </div>
//         )}
//         <Modal
//           show={addShow}
//           onHide={handleAddClose}
//           size="xl"
//           centered
//           className="animate__animated animate__zoomIn"
//           backdrop="static"
//         >
//           <Modal.Header closeButton className="bg-light">
//             <Modal.Title>
//               <div className="d-flex align-items-center">
//                 <i
//                   className={`ri-${
//                     values.marketingChannel === "email" ? "mail" : "whatsapp"
//                   }-line me-2 text-${
//                     values.marketingChannel === "email" ? "primary" : "success"
//                   }`}
//                 ></i>
//                 <div>
//                   <h5 className="mb-0">{selectedPackage?.packageName}</h5>
//                   <small className="text-muted">
//                     {values.marketingChannel === "email" ? "Email" : "WhatsApp"}{" "}
//                     Campaign
//                   </small>
//                 </div>
//               </div>
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <div className="row">
//               <div className="col-md-7">
//                 <div className="customer-selection-container">
//                   <div className="d-flex justify-content-between align-items-center mb-3">
//                     <div className="selection-info">
//                       <span className="badge bg-primary">
//                         {selectedCount}{" "}
//                         {selectedCount === 1 ? "Customer" : "Customers"}{" "}
//                         Selected
//                       </span>
//                     </div>
//                   </div>
//                   <div className="search-bar mb-3">
//                     <div className="input-group">
//                       <span className="input-group-text">
//                         <i className="ri-search-line"></i>
//                       </span>
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="Search customers..."
//                         value={customerSearchTerm}
//                         onChange={(e) => {
//                           setCustomerSearchTerm(e.target.value);
//                         }}
//                       />
//                        {customerSearchTerm && (
//                         <button
//                           className="btn btn-outline-secondary"
//                           type="button"
//                           onClick={() => {
//                             setCustomerSearchTerm("");
//                           }}
//                         >
//                           <i className="ri-close-line"></i>
//                         </button>
//                       )}
//                     </div>
//                   </div>

//                   <div className="table-responsive customer-table">
//                     <table className="table table-hover align-middle">
//                       <thead>
//                         <tr>
//                           <th width="50">
//                             <div className="form-check">
//                               <input
//                                 type="checkbox"
//                                 className="form-check-input"
//                                 onChange={handleSelectAll}
//                                 checked={
//                                   customers.length > 0 &&
//                                   customers.every((customer) =>
//                                     values.customerIds.includes(
//                                       customer.customerId
//                                     )
//                                   )
//                                 }
//                               />
//                             </div>
//                           </th>
//                           <th>Customer</th>
//                           <th>Contact</th>
//                           <th>Status</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {isLoading.customers ? (
//                           <tr>
//                             <td colSpan="4" className="text-center py-4">
//                               <div
//                                 className="spinner-grow text-primary"
//                                 role="status"
//                               >
//                                 <span className="visually-hidden">
//                                   Loading...
//                                 </span>
//                               </div>
//                             </td>
//                           </tr>
//                         ) : customers.length > 0 ? (
//                           customers.map((customer) => (
//                             <tr key={customer.customerId}>
//                               <td>
//                                 <div className="form-check">
//                                   <input
//                                     type="checkbox"
//                                     className="form-check-input"
//                                     onChange={(e) =>
//                                       handleCustomerSelection(
//                                         customer.customerId,
//                                         e.target.checked
//                                       )
//                                     }
//                                     checked={values.customerIds.includes(
//                                       customer.customerId
//                                     )}
//                                   />
//                                 </div>
//                               </td>
//                               <td>
//                                 <div className="d-flex align-items-center">
//                                   <div className="avatar-xs me-2">
//                                     <span className="avatar-title rounded-circle bg-soft-primary text-primary">
//                                       {customer.customerName[0].toUpperCase()}
//                                     </span>
//                                   </div>
//                                   <div>
//                                     <h6 className="mb-0">
//                                       {customer.customerName}
//                                     </h6>
//                                   </div>
//                                 </div>
//                               </td>
//                               <td>
//                                 <div>
//                                   <span className="d-block">
//                                     {customer.email}
//                                   </span>
//                                   <small>{customer.phoneNumber}</small>
//                                 </div>
//                               </td>
//                               <td>
//                                 <span className="badge bg-success">Active</span>
//                               </td>
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan="4" className="text-center py-4">
//                               <div className="text-muted">
//                                 <i className="ri-user-search-line display-5"></i>
//                                 <h5 className="mt-2">No customers found</h5>
//                                  {customerSearchTerm && (
//                                   <button
//                                     className="btn btn-link"
//                                     onClick={() => {
//                                       setCustomerSearchTerm("");
//                                     }}
//                                   >
//                                     Clear search
//                                   </button>
//                                 )}
//                               </div>
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-md-5">
//                 <div className="campaign-details-container">
//                   <ul className="nav nav-tabs mb-3">
//                     <li className="nav-item">
//                       <button
//                         className={`nav-link ${!previewMode ? "active" : ""}`}
//                         onClick={() => setPreviewMode(false)}
//                       >
//                         <i className="ri-edit-line me-1"></i> Compose
//                       </button>
//                     </li>
//                     <li className="nav-item">
//                       <button
//                         className={`nav-link ${previewMode ? "active" : ""}`}
//                         onClick={() => setPreviewMode(true)}
//                       >
//                         <i className="ri-eye-line me-1"></i> Preview
//                       </button>
//                     </li>
//                   </ul>

//                   {previewMode ? (
//                     renderPreview()
//                   ) : (
//                     <div className="compose-container">
//                       {values.marketingChannel === "whatsapp" && (
//                         <div className="mb-3">
//                           <label className="form-label">WhatsApp Message</label>
//                           <textarea
//                             className="form-control"
//                             rows="6"
//                             name="campaignMessage"
//                             value={values.campaignMessage}
//                             onChange={handleInputChange}
//                             placeholder="Type your WhatsApp message here..."
//                           ></textarea>
//                           <small className="text-muted">
//                             Max 1000 characters
//                           </small>
//                         </div>
//                       )}
//                       <div className="package-info-card p-3 border rounded mb-3">
//                         <h6>Package Details</h6>
//                         <div className="d-flex justify-content-between">
//                           <span className="text-muted">Name:</span>
//                           <span>{selectedPackage?.packageName}</span>
//                         </div>
//                         <div className="d-flex justify-content-between">
//                           <span className="text-muted">Price:</span>
//                           <span>
//                             {selectedPackage?.currency}{" "}
//                             {selectedPackage?.price.toLocaleString()}
//                           </span>
//                         </div>
//                         <div className="d-flex justify-content-between">
//                           <span className="text-muted">Duration:</span>
//                           <span>{selectedPackage?.duration}</span>
//                         </div>
//                         <div className="d-flex justify-content-between">
//                           <span className="text-muted">Travel Date:</span>
//                           <span>
//                             {selectedPackage?.startedDate
//                               ? moment(selectedPackage.startedDate).format(
//                                   "DD MMM YYYY"
//                                 )
//                               : ""}
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer className="bg-light">
//             <Button
//               variant="btn btn-danger"
//               onClick={handleAddClose}
//               disabled={btnLoading}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant={
//                 values.marketingChannel === "email" ? "primary" : "success"
//               }
//               onClick={handleSubmit}
//               disabled={btnLoading || values.customerIds.length === 0}
//             >
//               {btnLoading ? (
//                 <>
//                   <span className="spinner-border spinner-border-sm me-2"></span>
//                   Sending...
//                 </>
//               ) : (
//                 <>
//                   <i
//                     className={`ri-${
//                       values.marketingChannel === "email"
//                         ? "send-plane"
//                         : "whatsapp"
//                     }-line me-2`}
//                   ></i>
//                   Send{" "}
//                   {values.marketingChannel === "email"
//                     ? "Emails"
//                     : "WhatsApp Messages"}{" "}
//                   ({selectedCount})
//                 </>
//               )}
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </div>
//   );
// };

// export default Marketing;
import React, { useState, useEffect, useCallback } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Login from "../../Authentication/Login";
import { Link } from "react-router-dom";
import "animate.css";
import "./Marketing.css";
import moment from "moment";
import MarketingTabs from "../AllTabs/MarketingTabs";
import { toast } from "react-toastify";
// --- STEP 1: Import the reusable PackageShareModal ---
import PackageShareModal from "../Package/PackageShareModal";

const initialFieldValues = {
  campaignId: "00000000-0000-0000-0000-000000000000",
  marketingChannel: "",
  packageId: "",
  customerIds: [],
  campaignMessage: "",
};

const packageTypeOptions = ["Holiday", "Umrah", "Hajj"];

const Marketing = () => {
  const { user, loading, refreshUserProfile } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [addShow, setAddShow] = useState(false); // This is now ONLY for the email modal
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [previewMode, setPreviewMode] = useState(false);
  const [isLoading, setIsLoading] = useState({
    packages: false,
    customers: false,
  });
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [packageSearchTerm, setPackageSearchTerm] = useState("");
  const [customerSearchTerm, setCustomerSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("");
  const [customers, setCustomers] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);

  // --- STEP 2: Add new state for the reusable WhatsApp Modal ---
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);
  const [packageForWhatsapp, setPackageForWhatsapp] = useState(null);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);
  const [packages, setPackages] = useState([]);

  const resetForm = () => {
    setValues(initialFieldValues);
    setAddShow(false);
    setBtnLoading(false);
    setPackageSearchTerm("");
    setCustomerSearchTerm("");
    setFilterType("");
    setErrors({});
    setPreviewMode(false);
  };

  const handleAddClose = () => {
    resetForm();
  };

  // --- STEP 3: Update the WhatsApp share click handler ---
  const handleWhatsappShareClick = async (pkg) => {
    const updatedProfile = await refreshUserProfile();

    if (!updatedProfile || updatedProfile.connects <= 0) {
      toast.error(
        "You have no WhatsApp connects left. Please recharge to continue."
      );
      return;
    }

    // Fetch full package details required by PackageShareModal
    setIsFetchingDetails(true);
    try {
      const fullDetails = await apiService.get(
        `${config.GETPACKAGEDETAILS}/${pkg.packageId}`
      );
      setPackageForWhatsapp(fullDetails);
      setShowWhatsappModal(true); // Open the reusable modal
    } catch (error) {
      console.error("Failed to fetch full package details:", error);
      toast.error("Could not load package details for sharing.");
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const getPackages = useCallback(async () => {
    setIsLoading((prev) => ({ ...prev, packages: true }));
    try {
      let resourceUrl = `${config.GETPACKAGEBYCOMAPANYID}/${user?.cid}?PageNumber=${pageNumber}&PageSize=${pageSize}`;
      if (packageSearchTerm)
        resourceUrl += `&search=${encodeURIComponent(packageSearchTerm)}`;
      if (filterType) resourceUrl += `&type=${encodeURIComponent(filterType)}`;

      const res = await apiService.getAll(resourceUrl);
      setPackages(res.data);
      setTotalPages(res.totalPages);
      setTotalRecords(res.totalRecords);
    } catch (error) {
      console.error("Error fetching packages:", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, packages: false }));
    }
  }, [user?.cid, pageSize, pageNumber, packageSearchTerm, filterType]);

  const handleCustomerSelection = (customerId, isChecked) => {
    setValues((prev) => {
      const customerIds = isChecked
        ? [...prev.customerIds, customerId]
        : prev.customerIds.filter((id) => id !== customerId);
      return { ...prev, customerIds };
    });
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const filteredIds = customers.map((customer) => customer.customerId);
    setValues((prev) => ({
      ...prev,
      customerIds: isChecked
        ? [...new Set([...prev.customerIds, ...filteredIds])]
        : prev.customerIds.filter((id) => !filteredIds.includes(id)),
    }));
  };

  const validateEmail = () => {
    let temp = {};
    temp.customerIds = values.customerIds.length > 0;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  // --- STEP 4: Simplify handleSubmit to only handle email ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateEmail()) return;

    setBtnLoading(true);

    try {
      // The logic now only pertains to the email campaign
      await apiService.create(config.MARKETING, values);
      resetForm();
    } catch (error) {
      console.error("Error sending email campaign:", error);
      toast.error("Failed to send email campaign.");
    } finally {
      setBtnLoading(false);
    }
  };

  // --- STEP 5: Rename openPackageModal to openEmailModal for clarity ---
  const openEmailModal = (pkg, channel) => {
    setSelectedPackage(pkg);
    setCustomers([]);
    setCustomerSearchTerm("");
    setValues({
      ...initialFieldValues,
      packageId: pkg.packageId,
      marketingChannel: channel,
      // Default email message can be different if needed, or removed
      campaignMessage: `Exciting offer! ${pkg.packageName} for just ${
        pkg.currency
      } ${pkg.price.toLocaleString()}`,
      customerIds: [],
    });
    setAddShow(true);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers.map((number) => (
      <li
        className={`page-item ${pageNumber === number ? "active" : ""}`}
        key={number}
        onClick={() => setPageNumber(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    ));
  };

  const handleReset = () => {
    setPackageSearchTerm("");
    setFilterType("");
    setPageNumber(1);
    // getPackages will be called by the useEffect
  };

  useEffect(() => {
    if (user?.cid && !loading) {
      getPackages();
    }
  }, [loading, user?.cid, getPackages, pageNumber]);

  useEffect(() => {
    setPageNumber(1);
  }, [packageSearchTerm, filterType]);

  useEffect(() => {
    if (!addShow) return; // Only fetch customers for the email modal

    const getCustomers = async () => {
      setIsLoading((prev) => ({ ...prev, customers: true }));
      try {
        const url = `${config.GETALLCUSTOMERSBYCOMPANYID}/${user?.cid}${
          customerSearchTerm
            ? `?search=${encodeURIComponent(customerSearchTerm)}`
            : ""
        }`;
        const newCustomers = await apiService.getSingle(url);
        setCustomers(newCustomers);
        if (!customerSearchTerm) {
          setValues((prev) => ({
            ...prev,
            customerIds: newCustomers.map((c) => c.customerId),
          }));
        }
      } catch (error) {
        console.error("Error fetching customers:", error);
      } finally {
        setIsLoading((prev) => ({ ...prev, customers: false }));
      }
    };
    const debounceTimer = setTimeout(getCustomers, 300);
    return () => clearTimeout(debounceTimer);
  }, [addShow, customerSearchTerm, user?.cid]);

  useEffect(() => {
    setSelectedCount(values.customerIds.length);
  }, [values.customerIds]);

  const renderEmailPreview = () => {
    if (!selectedPackage) return null;
    return (
      <div className="preview-container p-4 border rounded bg-light">
        <div className="email-preview">
          <h5 className="text-primary">Email Preview</h5>
          <div className="email-content mt-3 p-3 bg-white rounded">
            <h4>Special Offer: {selectedPackage.packageName}</h4>
            <img
              src={
                selectedPackage.imageSrc ||
                "https://via.placeholder.com/600x300"
              }
              className="img-fluid rounded my-3"
              alt={selectedPackage.packageName}
            />
            <p>
              <strong>Package Details:</strong>
            </p>
            <ul>
              <li>Destination: {selectedPackage.packageName}</li>
              <li>Duration: {selectedPackage.duration}</li>
              <li>
                Price: {selectedPackage.currency}{" "}
                {selectedPackage.price.toLocaleString()}
              </li>
              <li>
                Start Date:{" "}
                {new Date(selectedPackage.startedDate).toLocaleDateString()}
              </li>
            </ul>
            <p>{selectedPackage.description}</p>
          </div>
        </div>
      </div>
    );
  };

  if (loading) return <p>Loading...</p>;
  if (!user) return <Login />;

  return (
    <div id="layout-wrapper" className="marketing-page">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="p-2">
                <MarketingTabs pageName="MARKETING" />
              </div>
              <div className="card-body">
                <div className="row g-3 mb-4">
                  <div className="col-xl-4 col-lg-6">
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Search packages..."
                        value={packageSearchTerm}
                        onChange={(e) => setPackageSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-xl-2 col-lg-3">
                    <select
                      name="filterType"
                      value={filterType}
                      onChange={(e) => setFilterType(e.target.value)}
                      className="form-select"
                    >
                      <option value="">All Types</option>
                      {packageTypeOptions.map((type, index) => (
                        <option key={index} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-xl-2 col-lg-3">
                    <div className="hstack gap-2">
                      <button className="btn btn-danger" onClick={handleReset}>
                        <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row g-4">
                  {isLoading.packages ? (
                    <div className="col-12 text-center py-5">
                      <div className="spinner-grow text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3 text-muted">Loading packages...</p>
                    </div>
                  ) : packages.length > 0 ? (
                    packages.map((pkg) => (
                      <div className="col-md-4 col-lg-3" key={pkg.packageId}>
                        <div
                          className={`card package-card h-100 animate__animated animate__fadeInUp`}
                        >
                          <div className="card-img-container">
                            <img
                              src={
                                pkg.imageSrc || "/images/default-package.jpg"
                              }
                              className="card-img-top"
                              alt={pkg.packageName}
                            />
                            <div className="price-badge">
                              <span>
                                {pkg.currency} {pkg.price.toLocaleString()} per
                                person
                              </span>
                            </div>
                          </div>
                          <div className="card-body">
                            <h5 className="">{pkg.packageName}</h5>
                            <span className="badge bg-info me-2">
                              {pkg.duration}
                            </span>
                            <span
                              className={`badge me-2 ${
                                pkg.status === "Active"
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {pkg.status}
                            </span>
                            <div className="package-meta d-flex justify-content-between mb-2 mt-1">
                              <span>
                                <i className="ri-calendar-line me-1"></i> Travel
                                Date :{" "}
                                {moment(pkg.startedDate).format("DD MMM YYYY")}
                              </span>
                              <span>
                                <i className="ri-user-line me-1"></i>
                                {pkg.noOfPersons}
                              </span>
                            </div>
                            <p className="card-text text-muted">
                              {pkg.description
                                ? `${pkg.description.substring(0, 80)}...`
                                : "No description available"}
                            </p>
                          </div>
                          <div className="card-footer">
                            <div className="d-flex justify-content-between align-items-center">
                              <Button
                                variant="success"
                                size="sm"
                                className="me-2"
                                onClick={() => handleWhatsappShareClick(pkg)}
                                title="WhatsApp Campaign"
                                disabled={isFetchingDetails}
                              >
                                {isFetchingDetails &&
                                packageForWhatsapp?.package.packageId ===
                                  pkg.packageId ? (
                                  <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                  <>
                                    Share <i className="ri-whatsapp-line"></i>
                                  </>
                                )}
                              </Button>
                              <Button
                                variant="primary"
                                size="sm"
                                onClick={() => openEmailModal(pkg, "email")}
                                title="Email Campaign"
                              >
                                Share <i className="ri-mail-line"></i>
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-12 text-center py-5">
                      <div className="text-muted">
                        <i className="ri-hotel-line display-5"></i>
                        <h5 className="mt-3">No packages available</h5>
                        <p>Please check back later or add new packages</p>
                      </div>
                    </div>
                  )}
                </div>
                <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                  <div className="flex-shrink-0">
                    <div className="text-muted">
                      Showing{" "}
                      <span className="fw-semibold">{packages.length}</span> of{" "}
                      <span className="fw-semibold">{totalRecords}</span>{" "}
                      Results
                    </div>
                  </div>
                  <ul className="pagination pagination-separated pagination-sm mb-0">
                    <li
                      className={`page-item ${
                        pageNumber === 1 ? "disabled" : ""
                      }`}
                      onClick={() =>
                        pageNumber > 1 && setPageNumber(pageNumber - 1)
                      }
                    >
                      <Link className="page-link">Previous</Link>
                    </li>
                    {renderPageNumbers()}
                    <li
                      className={`page-item ${
                        pageNumber === totalPages ? "disabled" : ""
                      }`}
                      onClick={() =>
                        pageNumber < totalPages && setPageNumber(pageNumber + 1)
                      }
                    >
                      <Link className="page-link">Next</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --- STEP 6: Render the reusable PackageShareModal --- */}
        {packageForWhatsapp && (
          <PackageShareModal
            show={showWhatsappModal}
            onHide={() => {
              setShowWhatsappModal(false);
              setPackageForWhatsapp(null); // Clean up data on close
            }}
            packageData={packageForWhatsapp}
            initialTemplateId="premium-modern" // Or any default you prefer
          />
        )}

        {/* This modal is now ONLY for Email Campaigns */}
        <Modal
          show={addShow}
          onHide={handleAddClose}
          size="xl"
          centered
          className="animate__animated animate__zoomIn"
          backdrop="static"
        >
          <Modal.Header closeButton className="bg-light">
            <Modal.Title>
              <div className="d-flex align-items-center">
                <i className={`ri-mail-line me-2 text-primary`}></i>
                <div>
                  <h5 className="mb-0">{selectedPackage?.packageName}</h5>
                  <small className="text-muted">Email Campaign</small>
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-7">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="selection-info">
                    <span className="badge bg-primary">
                      {selectedCount}{" "}
                      {selectedCount === 1 ? "Customer" : "Customers"} Selected
                    </span>
                  </div>
                </div>
                <div className="search-bar mb-3">
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-search-line"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search customers..."
                      value={customerSearchTerm}
                      onChange={(e) => setCustomerSearchTerm(e.target.value)}
                    />
                    {customerSearchTerm && (
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={() => setCustomerSearchTerm("")}
                      >
                        <i className="ri-close-line"></i>
                      </button>
                    )}
                  </div>
                </div>
                <div className="table-responsive customer-table">
                  <table className="table table-hover align-middle">
                    <thead>
                      <tr>
                        <th width="50">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              onChange={handleSelectAll}
                              checked={
                                customers.length > 0 &&
                                customers.every((c) =>
                                  values.customerIds.includes(c.customerId)
                                )
                              }
                            />
                          </div>
                        </th>
                        <th>Customer</th>
                        <th>Contact</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading.customers ? (
                        <tr>
                          <td colSpan="4" className="text-center py-4">
                            <div
                              className="spinner-grow text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </td>
                        </tr>
                      ) : customers.length > 0 ? (
                        customers.map((customer) => (
                          <tr key={customer.customerId}>
                            <td>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  onChange={(e) =>
                                    handleCustomerSelection(
                                      customer.customerId,
                                      e.target.checked
                                    )
                                  }
                                  checked={values.customerIds.includes(
                                    customer.customerId
                                  )}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="avatar-xs me-2">
                                  <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                                    {customer.customerName[0].toUpperCase()}
                                  </span>
                                </div>
                                <div>
                                  <h6 className="mb-0">
                                    {customer.customerName}
                                  </h6>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div>
                                <span className="d-block">
                                  {customer.email}
                                </span>
                                <small>{customer.phoneNumber}</small>
                              </div>
                            </td>
                            <td>
                              <span className="badge bg-success">Active</span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center py-4">
                            <div className="text-muted">
                              <i className="ri-user-search-line display-5"></i>
                              <h5 className="mt-2">No customers found</h5>
                              {customerSearchTerm && (
                                <button
                                  className="btn btn-link"
                                  onClick={() => setCustomerSearchTerm("")}
                                >
                                  Clear search
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-md-5">
                <ul className="nav nav-tabs mb-3">
                  <li className="nav-item">
                    <button
                      className={`nav-link ${!previewMode ? "active" : ""}`}
                      onClick={() => setPreviewMode(false)}
                    >
                      <i className="ri-edit-line me-1"></i> Compose
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link ${previewMode ? "active" : ""}`}
                      onClick={() => setPreviewMode(true)}
                    >
                      <i className="ri-eye-line me-1"></i> Preview
                    </button>
                  </li>
                </ul>
                {previewMode ? (
                  renderEmailPreview()
                ) : (
                  <div className="compose-container">
                    {/* Email specific compose section */}
                    <p>
                      Compose your email content here. The system will
                      automatically add package details.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="bg-light">
            <Button
              variant="btn btn-danger"
              onClick={handleAddClose}
              disabled={btnLoading}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={btnLoading || values.customerIds.length === 0}
            >
              {btnLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Sending...
                </>
              ) : (
                <>
                  <i className={`ri-send-plane-line me-2`}></i>Send Emails (
                  {selectedCount})
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default Marketing;
